// import store from '@/stores/store';
import {ModuleContext} from '@/stores/moduleConst';
import commonFn from '@/commons/commonFunction';
import {useContextStore} from '@/stores/context';
import {UserManager} from '@/commons/userManager';

class AuthService {
  constructor() {
    // Khởi tạo UserManager với config từ env
    this.userManager = new UserManager({
      client_id: window._misaId.clientId,
      authority: window._misaId.baseUrl,
      redirect_uri: window._misaId.redirectUri,
      post_logout_uri: window._misaId.logoutUri,
      request_type: 'spa',
      scopes: 'openid profile',
      response_mode: 'query',
      response_type: 'code'
    });
  }

  /**
   * Kiểm tra xem còn session đăng nhập ko
   */
  isAuthenticated() {
    const context = useContextStore();
    if (context.Token) {
      const expired = context.TokenExpired;
      if (expired && new Date(expired) > new Date()) {
        return true;
      }
    }
    return false;
  }

  /**
   * xử lý login qua misaid với PKCE
   * hàm này sẽ build link ra redirect qua trang misaid để login
   * Người sửa: NHCUONG 31.07.2025
   */
  login(callbackUrl) {
    commonFn.mask();
    
    try {
      // Sử dụng UserManager để generate secure login URL với PKCE
      // Pass callbackUrl như customState parameter
      const loginUrl = this.userManager.RedirectUrl(0, null, callbackUrl || '/');

      // Redirect đến trang login MISA ID
      location.href = loginUrl;
    } catch (error) {
      console.error('Lỗi khi tạo login URL:', error);
      commonFn.unmask();
      throw error;
    }
  }

  /**
   * Lấy thông tin client đã lưu trong localStorage
   * Sử dụng cho callback validation
   */
  getStoredClientInfo() {
    try {
      const clientInfo = localStorage.getItem(window._misaId.clientId);
      return clientInfo ? JSON.parse(clientInfo) : null;
    } catch (error) {
      console.error('Lỗi khi lấy thông tin client:', error);
      return null;
    }
  }

  /**
   * Xóa thông tin client đã lưu
   */
  clearStoredClientInfo() {
    localStorage.removeItem(window._misaId.clientId);
  }
}

export default new AuthService();
